<template>
    <div class="share">
        <div class="inner"><img id="draw-img" ref="drawImg" :src="shareSrc" alt=""><p>长按保存图片</p></div>
        <div ref="qrcodeContainer" id="qrcode" v-show="false"></div>
    </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import QRCode from 'qrcodejs2'
  export default {
    name: 'share',
    props: ['url', 'info', 'txt','activityData', 'shareDialog'],
    data () {
      return {
        shareSrc:'',
        isShow:false,
        canvas:{}
      }
    },
    computed: {
        ...mapState(["dialogData", "userInfo"])
    },
    mounted () {
        this.draw()
    },
    methods: {
        ...mapActions([
            "setPageLoadingAsync",
            "setDialogDataAsync",
            "setUserInfoAsync",
        ]),
        /** 	
         * 
         * 	ctx:  canvas绘图上下文
         * 	text:  需要绘制的文本内容
         *  textStyle: 绘制文本样式
         * 	width:  绘制后的文字显示宽度
         * 	lineNum:  最大行数，多出部分用'...'表示， 如果传-1可以达到自动换行效果
         * 	left:  绘制文字的起点 X 轴坐标
         * 	top:  绘制文字的起点 Y 轴坐标
         *	lineHeight:  文字行间距
        */
        writeText (ctx, text, textStyle, width, left, top, lineHeight, lineNum) {
            let lastIndex = 0
            let lineCount = 0
            let line = ''
            ctx.font = textStyle.font
            ctx.textAlign = textStyle.align || 'center'
            ctx.fillStyle = textStyle.color
            while (ctx.measureText(text).width > width) {
                for (let i = 0; ctx.measureText(text.slice(0, i)).width < width && i < text.length; i++) {   
                    lastIndex = i
                }
                lastIndex = this.getIndex(lastIndex, text)
                line = text.slice(0, lastIndex)
                text = text.slice(lastIndex, text.length) 
                ctx.fillText(text && lineCount >= lineNum -1 && lineNum !== -1 ? line.slice(0, lineCount === 0 ? -1 : -5) + '...' : line, left, top + lineHeight * lineCount)
                lineCount++        
                if (lineCount >= lineNum && lineNum !== -1) {         
                    break;
                }    
            }
            if (lineCount < lineNum || lineNum === -1) {
                ctx.fillText(text, left, top + lineHeight * lineCount)
            }
            return top + lineHeight * (lineCount + 1)
        },
        getIndex (i, text) {
            if (['，', '“', '”', '！', '、'].indexOf(text[i]) > -1) {
                return this.getIndex(i - 1, text)
            } else {
                return i
            }
        },

        draw () {
            this.canvas = document.createElement('canvas')
            this.canvas.width = 1080
            this.canvas.height = 1920
            const ctx = this.canvas.getContext('2d')
            new QRCode(this.$refs.qrcodeContainer, {  
                text: window.location.href,  
                width: 500,  
                height: 500,  
                colorDark: '#000000',  
                colorLight: '#ffffff',  
                correctLevel: QRCode.CorrectLevel.M  
            });
            // 绘制
            this.renderImage(ctx,this.canvas,this.url,this.info,this.txt)
        },
        renderImage (ctx,canvas,_url, info, txt) {
            const _this = this;
            const bg = _this.activityData.detailShareBg || 'https://yunyingcdn.thecover.cn/au_609a6b06e4faee003b0aaa89/20221115/7A4A9082-7418-F0DF-A6F4-89D7E3D83F23.jpg';
            const QRCodeImg = document.querySelector('#qrcode img').src || document.querySelector('#qrcode canvas').toDataURL("image/jpeg");
            Promise.all([
                this.loadImage(bg),
                this.loadImage(_this.url + '?imageMogr2/auto-orient/thumbnail/!438x438r/gravity/Center/crop/438x438|imageslim'),
                this.loadImage(QRCodeImg)
            ]).then((imgs)=>{
                
                _this.c_img = imgs[0]
                _this.p_img = imgs[1] 
                ctx.drawImage(_this.c_img, 0, 0, canvas.width, canvas.height);

                //title,标题不隐藏的话，则需要绘制出来
                if (!_this.activityData.shareImgTitleHidden && _this.activityData.title) {
                    _this.writeText(ctx,_this.activityData.title, {
                        font: 'normal 47px 黑体',
                        color: '#fff'
                    }, 900, (canvas.width)/2,300,55, 1);
                } 

                //头像
                if(_url !== ''){
                    _this.drawCircleRect(ctx, 'red', 315, 655, 454, 454, 20);
                    _this.drawCircleImg(ctx, _this.p_img, 323, 663, 438, 438, 18);
                };
                //名字
                if (info) {
                    _this.writeText(ctx,info, {
                        font: 'bold 47px 黑体',
                        color: '#1a1a1a'
                    }, 750, (canvas.width)/2,1200,55, !txt ? 2 : 1);                 
                }
                
                //简介 
                if (txt) {
                    _this.writeText(ctx,txt, {
                        font: 'normal 35px 黑体',
                        color: '#404040'
                    }, 600, (canvas.width)/2,1270,40, 2); 
                }   

                //二维码
                ctx.drawImage(imgs[2], 420, 1420, 240, 240);
                _this.shareSrc = canvas.toDataURL("image/jpeg");
                _this.$parent.getShareSrc();      
            })
            
        },
        // 预加载图片，最后返回一个promise对象
        loadImage(url) {
            const that = this
                return new Promise((resolve)=>{
                    const img = new Image();
                    img.onload = ()=>resolve(img);
                    img.src = url;
                    img.crossOrigin = 'anonymous'
                })
        },
        // 绘制圆角图片
        drawCircleImg ( ctx, img, x, y, w, h, r) {
            ctx.save()
            ctx.beginPath()
            ctx.arc(x + r, y + r, r, Math.PI, Math.PI*1.5)
            ctx.arc(x + w - r, y + r, r, Math.PI * 1.5, Math.PI * 2)
            ctx.arc(x + w - r, y + h - r, r, 0, Math.PI * 0.5)
            ctx.arc(x + r, y + h - r, r, Math.PI * 0.5, Math.PI)
            ctx.closePath()
            ctx.fill()
            ctx.clip()
            ctx.drawImage(img, x, y, w, h);
            ctx.restore()
        },
        // 绘制圆角矩形
        drawCircleRect ( ctx, color, x, y, w, h, r) {
            ctx.save()
            ctx.beginPath()
            ctx.fillStyle=color;
            ctx.arc(x + r, y + r, r, Math.PI, Math.PI*1.5)
            ctx.arc(x + w - r, y + r, r, Math.PI * 1.5, Math.PI * 2)
            ctx.arc(x + w - r, y + h - r, r, 0, Math.PI * 0.5)
            ctx.arc(x + r, y + h - r, r, Math.PI * 0.5, Math.PI)
            ctx.closePath()
            ctx.fill()
            ctx.clip()
            ctx.restore()
        }

    },
    
  }
  </script>
  <style lang="less" scoped>
  .share {
    background: rgba(0, 0, 0, 0.7);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 2000;
    p{
        color: #fff;
        font-size: 3vw;
        text-align: center;
    }
    .inner{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 3.2vw;
      height: 100%;
      overflow: hidden;
      img {
        width: auto;
        max-width: 90%;
        max-height: 80%;
      }
      p {
        line-height: 2.5;
        text-align: center;
        user-select: nonenpm;
      }
    }
  }
  </style>
  